function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
  let nameEQ = name + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function getURLParameter(name) {
  return new URLSearchParams(window.location.search).get(name) || '';
}

function getDevice(userAgent) {
  const devices = [
    { keyword: 'iPhone', name: 'iPhone' },
    { keyword: 'Windows', name: 'Windows Computer' },
    { keyword: 'Mac', name: 'Mac Computer' },
    { keyword: 'iPad', name: 'iPad' },
    { keyword: 'Android', name: 'Android' },
  ];
  return (
    devices.find((device) => userAgent.includes(device.keyword))?.name ||
    'unknown'
  );
}

function getReferrer(referrer) {
  if (referrer === '') return 'direct';
  const sources = [
    { regex: /https?:\/\/(.*)google\.[^/?]*/, name: 'google' },
    { regex: /https?:\/\/(.*)bing\.[^/?]*/, name: 'bing' },
    { regex: /https?:\/\/(.*)yahoo\.[^/?]*/, name: 'yahoo' },
    { regex: /https?:\/\/(.*)facebook\.[^/?]*/, name: 'facebook' },
    { regex: /https?:\/\/(.*)twitter\.[^/?]*/, name: 'twitter' },
    { regex: /https?:\/\/(.*)pinterest\.[^/?]*/, name: 'pinterest' },
    { regex: /https?:\/\/(.*)instagram\.[^/?]*/, name: 'instagram' },
  ];
  let source = sources.find((source) => referrer.search(source.regex) === 0);
  if (source) return source.name;
  let match = referrer.match(/https?:\/\/(?:www\.)?([^/:?#]+)(?:[/:?#]|$)/i);
  return match ? match[1] : 'unknown';
}

if (!getCookie('_user')) {
  setCookie('_user', 'true', 30);
  let userAgent = window.navigator.userAgent,
    device = getCookie('_u_de') || getDevice(userAgent),
    referrer = getCookie('_u_re') || getReferrer(document.referrer),
    fbc = getCookie('_fbc') || '',
    fbp = getCookie('_fbp') || '',
    fbclid = getURLParameter('fbclid') || '',
    utm = {
      source: getCookie('_u_so') || getURLParameter('utm_source') || 'organic',
      medium: getCookie('_u_me') || getURLParameter('utm_medium') || 'organic',
      campaign:
        getCookie('_u_ca') || getURLParameter('utm_campaign') || 'organic',
      gclid: getCookie('_u_gl') || getURLParameter('gclid') || '',
    },
    trackingData = { device, referrer, fbc, fbp, fbclid, ...utm };

  Object.entries(trackingData).forEach(([key, value]) => {
    if (!getCookie(`_u_${key.slice(0, 2)}`)) {
      setCookie(`_u_${key.slice(0, 2)}`, value, 30);
    }
  });

  window.trackingContext = {
    referrer,
    device,
    fbc,
    fbp,
    fbclid,
    utm,
    pixels: [''],
  };
}
